// /**
//  * Utility functions for catering quantity validation
//  */

// /**
//  * Validates if a quantity is valid for catering mode
//  * @param {number} quantity - The quantity to validate
//  * @param {number} minQty - The minimum quantity for catering
//  * @param {number} qtyIncrement - The increment step for catering
//  * @returns {boolean} - Whether the quantity is valid
//  */
// export const isValidCateringQuantity = (quantity, minQty = 1, qtyIncrement = 1) => {
//   // If quantity is 0, it's valid (means removing from cart)
//   if (quantity === 0) {
//     return true;
//   }

//   // Must be at least minQty
//   if (quantity < minQty) {
//     return false;
//   }

//   // Must be a valid increment from minQty
//   if (qtyIncrement > 1) {
//     const remainder = (quantity - minQty) % qtyIncrement;
//     return remainder === 0;
//   }

//   return true;
// };

// /**
//  * Adjusts a quantity to the nearest valid catering quantity
//  * @param {number} quantity - The quantity to adjust
//  * @param {number} minQty - The minimum quantity for catering
//  * @param {number} qtyIncrement - The increment step for catering
//  * @returns {number} - The adjusted quantity
//  */
// export const adjustToCateringQuantity = (quantity, minQty = 1, qtyIncrement = 1) => {
//   // If quantity is 0 or below minQty, return 0 (remove from cart) or minQty
//   if (quantity <= 0) {
//     return 0;
//   }

//   if (quantity < minQty) {
//     return minQty;
//   }

//   // If quantity is exactly minQty, it's valid
//   if (quantity === minQty) {
//     return quantity;
//   }

//   // If qtyIncrement is 1, any quantity >= minQty is valid
//   if (qtyIncrement <= 1) {
//     return quantity;
//   }

//   // Round down to nearest valid increment
//   const remainder = (quantity - minQty) % qtyIncrement;
//   if (remainder === 0) {
//     return quantity; // Already valid
//   }

//   return minQty + Math.floor((quantity - minQty) / qtyIncrement) * qtyIncrement;
// };

/**
 * Gets the next valid catering quantity when incrementing
 * @param {number} currentQuantity - The current quantity
 * @param {number} minQty - The minimum quantity for catering
 * @param {number} qtyIncrement - The increment step for catering
 * @param {number} maxQty - The maximum allowed quantity
 * @returns {number} - The next valid quantity
 */
export const getNextCateringQuantity = (currentQuantity, minQty = 1, qtyIncrement = 1, maxQty = 999) => {
  if (currentQuantity === 0) {
    return minQty;
  }

  const nextQuantity = currentQuantity + qtyIncrement;
  return nextQuantity <= maxQty ? nextQuantity : currentQuantity;
};

/**
 * Gets the previous valid catering quantity when decrementing
 * @param {number} currentQuantity - The current quantity
 * @param {number} minQty - The minimum quantity for catering
 * @param {number} qtyIncrement - The increment step for catering
 * @returns {number} - The previous valid quantity
 */
export const getPreviousCateringQuantity = (currentQuantity, minQty = 1, qtyIncrement = 1) => {
  const previousQuantity = currentQuantity - qtyIncrement;
  return previousQuantity < minQty ? 0 : previousQuantity;
};
